module.exports = __webpack_public_path__ + "media/img/info/jobs-8c233de3f6dda64e141f1f36fa46b80c.png";